import { render, staticRenderFns } from "./QuestionResult1.vue?vue&type=template&id=426c6313&scoped=true&"
import script from "./QuestionResult1.vue?vue&type=script&lang=js&"
export * from "./QuestionResult1.vue?vue&type=script&lang=js&"
import style0 from "./QuestionResult1.vue?vue&type=style&index=0&id=426c6313&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426c6313",
  null
  
)

component.options.__file = "QuestionResult1.vue"
export default component.exports